export default {
    common: {
        title: "Rediger billede",
        cancel: "Annuller",
        save: "Gem",
        crop: "afgrøde",
        adjustments: "Justeringer",
        filters: "Filtre",
        frames: "Rammer",
        overlays: "Overlejringer",
        text: "Tekst",
        stickers: "Klistre­mærker",
        brush: "Børste",
        ai: "Opret billede ved hjælp af AI",
        reset: "Nulstil",
        comingSoon: 'Kommer snart...',
    },
};
